import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Rater from 'react-rater';
import { connect } from 'react-redux';
import {
  Field, reduxForm, change,
} from 'redux-form';
import SubmitReviewFormButton from './SubmitReviewFormButton';
import Star from './star/Star';
import InputWrapper from './redux_form_wrappers/InputWrapper';
import { reviewsActions } from '../../../actions';
import {
  reviewSubmittingSelector, reviewSubmittingError, reviewRatingSelector, reviewSubmittedSelector,
} from '../../../selectors/review_form';
import TextAreaWrapper from './redux_form_wrappers/TextAreaWrapper';
import validations from '../../../../services/validations';
import styles from './SubmitReviewForm.module.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import closeIcon from '../../../../../images/icons/close-white.svg';
import plusSign from '../../../../../images/icons/plus-lillac.svg';

function NotLoggedInFields() {
  return (
    <>
      <Field
        name="username"
        placeholder="Name*"
        type="text"
        component={InputWrapper}
        alt="name"
        className={styles['review-form-input']}
      />
      <Field
        name="email"
        placeholder="Email*"
        component={InputWrapper}
        type="email"
        alt="email"
        className={styles['review-form-input']}
      />
    </>
  );
}

class SubmitReviewForm extends Component {
  fileInputRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      images: [],
    };
  }

  componentDidMount() {
    const { isCampaign } = this.props;
    if (isCampaign) {
      this.setRatingValue({ rating: 5 });
    }
  }

  setRatingValue = ({ rating }) => {
    const { setFieldValue } = this.props;
    setFieldValue('rating', rating);
  };

  onImageSelected = (event) => {
    event.stopPropagation();
    event.preventDefault();

    const { files } = event.target;

    if (files.length === 0) { return; }

    const lookup = {};

    this.setState((prevState) => ({
      images: [...prevState.images, ...files].filter(
        (image) => {
          if (!lookup[image.name]) {
            lookup[image.name] = true;
            return true;
          }
          return false;
        },
      ),
    }), () => {
      this.fileInputRef.value = '';
    });
  };

  onImageRemove = (imageToRemove) => {
    const { images } = this.state;
    const newImages = images.filter((image) => image.name !== imageToRemove.name);
    this.setState({
      images: newImages,
    });
  };

  submitForm = (params) => {
    const { submitReviewRequest, sourceId, isCampaign } = this.props;
    const { images } = this.state;
    submitReviewRequest({ sourceId, params: { ...params, images }, isCampaign });
  };

  render() {
    const {
      userLoggedIn, reviewSubmitting, rating = 0, customFullButtonStyle, customColor,
      isCampaign, handleSubmit,
    } = this.props;
    const { images } = this.state;

    return (
      <form className={styles['review-form']} onSubmit={handleSubmit(this.submitForm)}>
        { !isCampaign && (
          <>
            <span className={styles['review-rating-label']}>overall review*</span>
            <Rater total={5} rating={Number(rating)} onRate={this.setRatingValue}>
              <Star color={customColor} />
            </Rater>
          </>
        )}
        <Field
          name="rating"
          component="input"
          type="number"
          placeholder="rating"
          alt="rating"
          value={rating}
          className={styles['hidden-rating-input']}
        />
        { !userLoggedIn && <NotLoggedInFields /> }
        {/* <Field
          name="title"
          component={InputWrapper}
          type="text"
          placeholder="Your opinion in one sentence*"
          alt="your opinion"
          className={styles['review-form-input']}
        /> */}
        <Field
          name="content"
          type="text"
          component={TextAreaWrapper}
          placeholder="Write your comments here*"
          alt="review text"
          className={styles['review-text']}
        />
        <input
          type="file"
          ref={(ref) => { this.fileInputRef = ref; }}
          onChange={this.onImageSelected}
          multiple
          accept="image/*"
        />
        { images.length === 0 && !isCampaign && (
          <ClickableDiv className={styles['add-photo']} onClick={() => { this.fileInputRef.click(); }}>
            + Add photo
          </ClickableDiv>
        )}
        { images.length > 0 && (
          <div className={styles.images}>
            { images.map((image) => (
              <div className={styles.image} key={image.name}>
                <ClickableDiv className={styles.overlay} onClick={() => this.onImageRemove(image)}>
                  <img src={closeIcon} alt="remove" />
                </ClickableDiv>
                <img src={URL.createObjectURL(image)} alt="review" />
              </div>
            ))}
            <ClickableDiv className={styles['add-photo']} onClick={() => { this.fileInputRef.click(); }}>
              <img src={plusSign} alt="plus" />
            </ClickableDiv>
          </div>
        )}
        <SubmitReviewFormButton
          customFullButtonStyle={customFullButtonStyle}
          loading={reviewSubmitting}
          isCampaign={isCampaign}
        />
      </form>
    );
  }
}

const SubmitReviewFormWithForm = reduxForm({
  form: 'submitReviewForm',
  enableReinitialize: true,
  validate: validations.submitReviewForm,
})(SubmitReviewForm);

SubmitReviewForm.propTypes = {
  userLoggedIn: PropTypes.bool.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  reviewSubmitting: PropTypes.bool,
  rating: PropTypes.number,
  customFullButtonStyle: PropTypes.string,
  customColor: PropTypes.string.isRequired,
  isCampaign: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  submitReviewRequest: PropTypes.func.isRequired,
  sourceId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  reviewSubmitting: reviewSubmittingSelector(state),
  reviewSubmittingError: reviewSubmittingError(state),
  reviewSubmitted: reviewSubmittedSelector(state),
  rating: reviewRatingSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setFieldValue: (field, value) => dispatch(change('submitReviewForm', field, value)),
  submitReviewRequest: (params) => dispatch(reviewsActions.submitReviewRequest(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmitReviewFormWithForm);
